export default __webpack_public_path__ + "static/media/firststepsm.e372af7a.png";